import React from 'react';
import { Card } from 'react-bootstrap';

import GenericCardRenderItems from './GenericCardRenderItems';

const ComplementoCartaPorteFiguraTransporteResumen = ({ data = {} }) => {

  const render = (item) => (
    <GenericCardRenderItems
      key={ item.id }
      data={ item }
      labels={ labels }
    />
  )

  return (
    <>
      { !!data.FiguraTransporte.TiposFigura &&  (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Figura Transporte</strong>
          </div>

          <Card className="mb-2">
            <Card.Body>
              { data.FiguraTransporte.TiposFigura.map(render) }
            </Card.Body>
          </Card>
        </>
      ) }
    </>
  )
}

const labels = [
  {
    label: 'Tipo Figura',
    index: 'TipoFigura'
  },
  {
    label: 'RFC Figura',
    index: 'RFCFigura',
  },
  {
    label: 'Número de Licencia',
    index: 'NumLicencia',
  },
  {
    label: 'Nombre Figura',
    index: 'NombreFigura',
  },
  {
    label: 'Residencia Fiscal Figura',
    index: 'ResidenciaFiscalFigura'
  }
];

export default ComplementoCartaPorteFiguraTransporteResumen;
